import assessment from "app/reducers/assessment";
import blank from "app/reducers/blank";
import notifications from "app/reducers/notifications";
import combineReducers from "lib/combine-reducers";

export const createInitialState = ({user, ...app} = {}) => ({
  app: app || {},
  assessment: null,
  notifications: [],
  user
});

export default combineReducers({
  app: blank,
  assessment,
  notifications,
  user: blank
});
